import { graphql } from '@/gql';
import { queryExecute } from '@/Utils/graphqlAPI';

export const getPlaceTypesByGeocode = async (latitude: number, longitude: number): Promise<string[]> => {
  const response = await queryExecute({
    fetchPolicy: 'no-cache',
    variables: {
      latitude,
      longitude,
    },
    query: graphql(`
      query GetPlaceTypesByGeocode($latitude: Float!, $longitude: Float!) {
        getPlaceTypesByGeocode(latitude: $latitude, longitude: $longitude)
      }
    `),
  });

  return response.data.getPlaceTypesByGeocode ?? [];
};
